<!--
Voting college selection screen
@author ab557z
-->
<template>
  <div id="contain" class="container">
  <Nav name="Select a College" />
  <div class="vContainer">
      <p style="margin-top:16px" class="votingInstructions">Colleges listed are not necessarily contested at every election.
      Once made, your selection cannot be changed until the next election year.</p>
      <ul class="list-group">
        <li v-for="value in values" :key="value.ouCode" @click="saveChoice(value.ouCode)" style="margin-bottom:10px;" class="list-group-item electionLink">
          <font-awesome-icon style="margin-top:6px;" icon="arrow-right" size="sm" class="menuChev"></font-awesome-icon>
          <b>{{value.name}}</b>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>

import { ref, onMounted } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'

const router = useRouter()
const values = ref({})

onMounted(() => {
  // Fetch the sms setting from the the server. There are only 2 editable setting right now. DOESNT WORK
  axios.get('/vote/rest/college')
      .then(response => {
        values.value = {}
        values.value = response.data
      })
})

// Saves setting change back to server
function saveChoice (college) {
axios.post('/vote/rest/college/save?collegeId=' + college)
  .then(response => {
    if (response.data == 'OK') {
      router.push('/voting/school')
    } else {
      alert(response.data,
      () => {
        router.push('/')
      })
    }
  })
}
</script>
